import DecreaseDailyIncomeFilter from "./DecreaseDailyIncomeFilter";
import DecreaseDailyIncomeItem from "./DecreaseDailyIncomeItem";

const DecreaseDailyIncome = () => {
  return (
    <>
      <DecreaseDailyIncomeFilter />
      <DecreaseDailyIncomeItem />
    </>
  );
};

export default DecreaseDailyIncome;
